import React from "react"
import Blognavbar from "../Components/blognavbar"
import BlogFooter from "../Components/blogfooter"
import "../Styles/blog.scss"
import NewsCat from '../Components/blogCats/news'
import ConcertCat from '../Components/blogCats/concert'
import ArticleCat from '../Components/blogCats/article'
import { fab } from "../../node_modules/@fortawesome/free-brands-svg-icons"
import { library } from "../../node_modules/@fortawesome/fontawesome-svg-core";
import {
  faHashtag,
  faEnvelope,
  faPhone,
} from "../../node_modules/@fortawesome/free-solid-svg-icons"
library.add(fab, faHashtag, faEnvelope, faPhone);



const BlogPage = () => {
  return (
    <div className="blog-body">
      <Blognavbar></Blognavbar>
      <div className="blog-body-div">
        <NewsCat/>
      <ArticleCat/>
      <ConcertCat/>
        </div>
      
      <BlogFooter></BlogFooter>
    </div>
  )
}

export default BlogPage
